import * as types from './types'

export const getLoanRolloverSplits = (payload: any) => ({
  type: types.GET_LOAN_ROLLOVER_SPLITS,
  payload,
})

export const getApprovedLoanRolloverSplits = (payload: any) => ({
  type: types.GET_APPROVED_LOAN_ROLLOVER_SPLITS,
  payload,
})

export const addLoanRolloverSplit = (payload: any) => ({
  type: types.ADD_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const editLoanRolloverSplit = (payload: any) => ({
  type: types.EDIT_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const submitLoanRolloverSplit = (payload: any) => ({
  type: types.SUBMIT_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const approveLoanRolloverSplit = (payload: any) => ({
  type: types.APPROVE_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const rejectLoanRolloverSplit = (payload: any) => ({
  type: types.REJECT_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const deleteLoanRolloverSplit = (payload: any) => ({
  type: types.DELETE_LOAN_ROLLOVER_SPLIT,
  payload,
})

export const startLoadingLoanRolloverSplit = () => ({
  type: types.START_LOADING_LOAN_ROLLOVER_SPLIT,
  payload: null,
})

export const stopLoadingLoanRolloverSplit = () => ({
  type: types.STOP_LOADING_LOAN_ROLLOVER_SPLIT,
  payload: null,
})
